import * as React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import MainCalendarView from './MainCalendarView';
import MobileCalendarView from './mobile/MobileCalendarView';

/**
 * Calendar page wrapper that shows the appropriate view based on screen size.
 * - Desktop (md and up): Full-featured calendar with drag-drop, multi-column view
 * - Mobile (below md): Simplified single-day, single-resource view
 */
function CalendarPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return <MobileCalendarView />;
  }

  return <MainCalendarView />;
}

export default CalendarPage;
